import { render, staticRenderFns } from "./TabelaPrincipal.vue?vue&type=template&id=11a48397&scoped=true&"
import script from "./TabelaPrincipal.vue?vue&type=script&lang=js&"
export * from "./TabelaPrincipal.vue?vue&type=script&lang=js&"
import style0 from "./TabelaPrincipal.vue?vue&type=style&index=0&id=11a48397&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11a48397",
  null
  
)

export default component.exports